import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function AnswerViewExpiredLinkIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 251 250'
      fill='none'
    >
      <g filter='url(#filter0_i_7663_9628)'>
        <rect
          x='0.5'
          width='250'
          height='250'
          rx='125'
          fill='#F0F5FF'
        />
        <g filter='url(#filter1_d_7663_9628)'>
          <rect
            x='42'
            y='129.383'
            width='91.3853'
            height='52.6158'
            rx='14'
            stroke='#061178'
            strokeWidth='12'
            fill='none'
          />
          <rect
            x='98.5391'
            y='110'
            width='91.3853'
            height='51.0004'
            rx='14'
            stroke='#1F52B3'
            strokeWidth='12'
            fill='none'
          />
        </g>
        <g filter='url(#filter2_d_7663_9628)'>
          <path
            d='M209.327 105.922C212.46 88.2066 200.639 71.3052 182.924 68.1719C165.208 65.0386 148.307 76.8599 145.173 94.5755C142.04 112.291 153.861 129.192 171.577 132.326C189.292 135.459 206.194 123.638 209.327 105.922Z'
            fill='#3E8FFA'
          />
        </g>
        <path
          d='M190.678 91.1409L186.057 86.5195L165.361 107.215L169.982 111.837L190.678 91.1409Z'
          fill='white'
        />
        <path
          d='M169.991 86.4958L165.37 91.1172L186.066 111.813L190.687 107.192L169.991 86.4958Z'
          fill='white'
        />
      </g>
      <defs>
        <filter
          id='filter0_i_7663_9628'
          x='0.5'
          y='0'
          width='259'
          height='270'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='9'
            dy='25'
          />
          <feGaussianBlur stdDeviation='10' />
          <feComposite
            in2='hardAlpha'
            operator='arithmetic'
            k2='-1'
            k3='1'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.7275 0 0 0 0 0.810305 0 0 0 0 0.97 0 0 0 0.6 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_7663_9628'
          />
        </filter>
        <filter
          id='filter1_d_7663_9628'
          x='34'
          y='104'
          width='173.925'
          height='101'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_7663_9628'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_7663_9628'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_d_7663_9628'
          x='142.67'
          y='67.668'
          width='79.1602'
          height='82.1602'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_7663_9628'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_7663_9628'
            result='shape'
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
